import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllSchools() {
  return get(`${apiHost}/api/admin/schools`);
}
